module.exports = __webpack_public_path__ + "img/inter4.4465d52e.jpg";